"use strict";
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegendMarkerEnum = void 0;
var LegendMarkerEnum;
(function (LegendMarkerEnum) {
    LegendMarkerEnum["NONE"] = "NONE";
    LegendMarkerEnum["MISSED"] = "MISSED";
    LegendMarkerEnum["OPEN"] = "OPEN";
    LegendMarkerEnum["ENDING"] = "ENDING SOON";
    LegendMarkerEnum["RECURRING"] = "RECURRING";
})(LegendMarkerEnum = exports.LegendMarkerEnum || (exports.LegendMarkerEnum = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGVnZW5kLW1hcmtlci1lbnVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbW1vbi9lbnVtcy9sZWdlbmQtbWFya2VyLWVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7R0FNRzs7O0FBRUgsSUFBWSxnQkFNWDtBQU5ELFdBQVksZ0JBQWdCO0lBQzFCLGlDQUFhLENBQUE7SUFDYixxQ0FBaUIsQ0FBQTtJQUNqQixpQ0FBYSxDQUFBO0lBQ2IsMENBQXNCLENBQUE7SUFDdEIsMkNBQXVCLENBQUE7QUFDekIsQ0FBQyxFQU5XLGdCQUFnQixHQUFoQix3QkFBZ0IsS0FBaEIsd0JBQWdCLFFBTTNCIn0=